import React from 'react';
import { Card, Flex, Text, Inset } from '@radix-ui/themes';

import { useRecentMetric } from '@/database/repositories/metricLogRepository';
import { DynamicIcon } from '../DynamicIcon';
import { MetricChart } from './MetricChart';
import MediaChart from './MediaChart';
import { useModalStore } from '@/state/useModalStore';

interface DisplayBoxProps {
  metricId: string;
}

export default function DetailCallout({ metricId }: DisplayBoxProps) {
  const openModal = useModalStore((state) => state.openModal);
  const metric = useRecentMetric(metricId);
  if (metric === undefined) {
    return null;
  }
  if (metric.entries === undefined) {
    metric.entries = [];
  }

  return (
    <Card
      size="2"
      style={{
        aspectRatio: '1 / 1',
        width: '100%',
        maxHeight: '300px',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
      }}
      onClick={() => openModal('SINGLE_METRIC', { metricId })}
    >
      <Flex align="center" gap="2" mb="3">
        <Flex align="center" justify="center" className="text-current">
          <DynamicIcon name={metric?.icon} />
        </Flex>
        <Text as="div" size="3" weight="bold" trim="normal">
          {metric.name ?? '---'}
        </Text>
      </Flex>

      <Inset
        clip="padding-box"
        side="bottom"
        pb="0"
        style={{ flex: 1, minHeight: 0 }}
      >
        {metric.entryType === 'media' && <MediaChart data={metric.entries} />}
        {metric.entryType === 'number' && (
          <MetricChart data={metric.entries} chartType={metric.chartType} />
        )}
      </Inset>
    </Card>
  );
}
